import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmitService {
  @Output() data = new EventEmitter<any>();
  @Output() accion = new EventEmitter<string>();
  @Output() loguear = new EventEmitter<string>();

  constructor() { }

  enviarData(recibeData:any){
    this.data.emit(recibeData);
  }

  enviarLogin(data:string){
    this.loguear.emit(data);
  }
}
